const FeedbackIcon = () => (
	<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7.91634 7.89974H7.92467M12.083 7.89974H12.0913M7.91634 11.2331C8.18791 11.5102 8.51205 11.7304 8.86978 11.8808C9.22751 12.0311 9.61164 12.1085 9.99967 12.1085C10.3877 12.1085 10.7718 12.0311 11.1296 11.8808C11.4873 11.7304 11.8114 11.5102 12.083 11.2331M3.33301 17.8997V7.06641C3.33301 6.40337 3.5964 5.76748 4.06524 5.29864C4.53408 4.8298 5.16997 4.56641 5.83301 4.56641H14.1663C14.8294 4.56641 15.4653 4.8298 15.9341 5.29864C16.4029 5.76748 16.6663 6.40337 16.6663 7.06641V12.0664C16.6663 12.7294 16.4029 13.3653 15.9341 13.8342C15.4653 14.303 14.8294 14.5664 14.1663 14.5664H6.66634L3.33301 17.8997Z"
			stroke="#5B5B5B"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export default FeedbackIcon;
